<script setup lang="ts">
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome'
import { computed } from 'vue'
import { CONTACT_MAIL } from '@/config/config.ts'

interface Props {
  icon: string[]
  href?: string
  text?: string
  size?: FontAwesomeIconProps["size"]
}

const props = withDefaults(defineProps<Props>(), {
  icon: () => [],
  href: `mailto:${CONTACT_MAIL}`,
  text: '',
})

const linkAttributes = computed(() => {
  if (props.href.startsWith('http')) {
    return {
      target: '_blank',
      rel: 'noopener noreferrer'
    }
  }
  return {}
})
</script>

<template>
  <a
    :href="props.href"
    v-bind="linkAttributes"
    class="text-[14px] font-normal text-white flex items-center gap-3 hover:text-yellowCustom"
  >
    <font-awesome-icon :icon="props.icon" v-bind="props.size ? { size: props.size } : {}"/>
    <span v-if="props.text">{{ props.text }}</span>
  </a>
</template>
